import React, { useState, useRef } from "react";
import "./AttendanceCard.css";
const getTimeInMinutes = (datetimeStr) => {
  if (!datetimeStr) return 0;
  const [datePart, timePart] = datetimeStr.split("T");
  if (!timePart) return 0;
  const [hours, minutes] = timePart.split(":").map(Number);
  const day = new Date(datePart).getDate();  // Use day number as day offset
  return day * 1440 + hours * 60 + minutes;   // total minutes
};

const formatDateTimeInput = (dateTimeStr) => {
  if (!dateTimeStr) return "";

  // Remove milliseconds and seconds if present
  const cleaned = dateTimeStr.trim().substring(0, 16);

  // Ensure format is YYYY-MM-DDTHH:mm
  return cleaned.includes("T") ? cleaned : cleaned.replace(" ", "T");
};

const formatTime = (dateTimeString) => {
  if (!dateTimeString || typeof dateTimeString !== "string") return "";
  const [datePart, timePart] = dateTimeString.split("T");
  return timePart ? timePart.substring(0, 5) : "";
};

const AttendanceCard = ({ data, originalData, onChange, isDisabled, isSelected, onSelectToggle, isApprovedCard }) => {
  const displayText = `${data.employee_code} - ${data.display_name}`.substring(0, 30);

  const [regInTime, setRegInTime] = useState(formatDateTimeInput(data.reg_in_punch));
  const [regOutTime, setRegOutTime] = useState(formatDateTimeInput(data.reg_out_punch));

  const originalRegInRef = useRef(formatDateTimeInput(data.reg_in_punch));
  const originalRegOutRef = useRef(formatDateTimeInput(data.reg_out_punch));
  const longPressTimeout = useRef(null);
  const [markAbsent, setMarkAbsent] = useState(data.markAbsent === 'Y');

  const status = data.punch_mark || "-";
  const workingHours = data.working_hours || "0.00";
  const otHours = data.ot_hours || "00:00";

  const canBeApproved = () => {
    if (data.markAbsent === 'Y') return true;
  
    const inTime = data.reg_in_punch || data.in_punch;
    const outTime = data.reg_out_punch || data.out_punch;
  
    if (!inTime || !outTime) {
      alert("❗ Both IN and OUT punch times must be entered before approval.");
      return false;
    }
  
    return true;
  };
  
  /*
  const handleRegInChange = (e) => {
    const pickedValue = e.target.value;
  
    if (pickedValue) {
      // Force date to fixed attendance date, only take time from picker
      const pickedTime = pickedValue.split("T")[1];
      const fixedDate = data.attendance_date.split("T")[0];
      const correctedInTime = `${fixedDate}T${pickedTime}`;
  
      const outTimeRaw = regOutTime || data.out_punch;
  
      if (outTimeRaw) {
        const inMinutes = getTimeInMinutes(correctedInTime);
        const outMinutes = getTimeInMinutes(outTimeRaw);
        const diffHours = Math.abs(outMinutes - inMinutes) / 60;
  
        if (diffHours > 24) {
          alert("❗ IN and OUT time difference cannot exceed 24 hours.");
          return;
        }
      }
  
      setRegInTime(correctedInTime);
      onChange({ ...data, reg_in_punch: correctedInTime, reg_out_punch: regOutTime });    
    } else {
      setRegInTime("");
      onChange({ ...data, reg_in_punch: "", reg_out_punch: regOutTime });
    }
  };
  */
  
  /*
  const handleRegOutChange = (e) => {
    const pickedValue = e.target.value;
    if (pickedValue) {
      const inTimeRaw = regInTime || data.in_punch;
      if (!inTimeRaw) {
        alert("❗ In Punch time not found.");
        return;
      }
  
      const inMinutes = getTimeInMinutes(inTimeRaw);
      const outMinutes = getTimeInMinutes(pickedValue);
      const diffMinutes = Math.abs(outMinutes - inMinutes);
  
      if (diffMinutes > 1440) {
        alert("❗ IN and OUT time difference cannot exceed 24 hours.");
        return;
      }
  
      setRegOutTime(pickedValue);
      onChange({ ...data, reg_in_punch: regInTime, reg_out_punch: pickedValue });
    } else {
      setRegOutTime("");
      onChange({ ...data, reg_in_punch: regInTime, reg_out_punch: "" });
    }
  };
  */    

  const handleRegInChange = (e) => {
    const pickedValue = e.target.value;
  
    if (pickedValue) {
      const pickedTime = pickedValue.split("T")[1];
  
      // ✅ Ensure a valid time part is selected
      if (!pickedTime || pickedTime.length < 5) return;
  
      const fixedDate = data.attendance_date.split("T")[0];
      const correctedInTime = `${fixedDate}T${pickedTime}`;
  
      const outTimeRaw = regOutTime || data.out_punch;
  
      if (outTimeRaw) {
        const inMinutes = getTimeInMinutes(correctedInTime);
        const outMinutes = getTimeInMinutes(outTimeRaw);
        const diffHours = Math.abs(outMinutes - inMinutes) / 60;
  
        if (diffHours > 24) {
          alert("❗ IN and OUT time difference cannot exceed 24 hours.");
          return;
        }
      }
  
      setRegInTime(correctedInTime);
      onChange({ ...data, reg_in_punch: correctedInTime, reg_out_punch: regOutTime });
  
    } else {
      setRegInTime("");
      onChange({ ...data, reg_in_punch: "", reg_out_punch: regOutTime });
    }
  };

  const handleRegOutChange = (e) => {
    const pickedValue = e.target.value;
  
    if (pickedValue) {
      const pickedTime = pickedValue.split("T")[1];
  
      // ✅ Ensure a valid time is selected before proceeding
      if (!pickedTime || pickedTime.length < 5) return;
  
      const inTimeRaw = regInTime || data.in_punch;
  
      if (!inTimeRaw) {
        alert("❗ In Punch time not found.");
        return;
      }
  
      //const outDate = data.attendance_date.split("T")[0];
      //const correctedOutTime = `${outDate}T${pickedTime}`;
      const correctedOutTime = pickedValue;  // ✅ Use full value including actual date

      const inMinutes = getTimeInMinutes(inTimeRaw);
      const outMinutes = getTimeInMinutes(correctedOutTime);
      const diffMinutes = Math.abs(outMinutes - inMinutes);
  
      if (diffMinutes > 1440) {
        alert("❗ IN and OUT time difference cannot exceed 24 hours.");
        return;
      }
  
      setRegOutTime(correctedOutTime);
      onChange({ ...data, reg_in_punch: regInTime, reg_out_punch: correctedOutTime });
  
      // No approval logic here — approval validation handled only during selection
    } else {
      setRegOutTime("");
      onChange({ ...data, reg_in_punch: regInTime, reg_out_punch: "" });
    }
  };
    
  const resetTimes = () => {
    setRegInTime(originalRegInRef.current);
    setRegOutTime(originalRegOutRef.current);
    onChange({ ...data, reg_in_punch: originalRegInRef.current, reg_out_punch: originalRegOutRef.current });
  };

  const handleDoubleClick = () => {
    if (!isDisabled && onSelectToggle) {
      if (!isSelected && !canBeApproved()) return;
      onSelectToggle();
    }
  };
    
  const handleTouchStart = (e) => {
    e.preventDefault();
    if (!isDisabled && onSelectToggle) {
      longPressTimeout.current = setTimeout(() => {
        if (!isSelected && !canBeApproved()) return;
        onSelectToggle();
      }, 500);
    }
  };
  
  const handleTouchEnd = () => {
    clearTimeout(longPressTimeout.current);
  };

  const handleTouchCancel = () => {
    clearTimeout(longPressTimeout.current);
  };

  const handleMarkAbsentChange = (e) => {
    const isChecked = e.target.checked;
    setMarkAbsent(isChecked);
    onChange({
      ...data,
      markAbsent: isChecked ? 'Y' : 'N'
    });
    //if (!isSelected && onSelectToggle) onSelectToggle();
    if (!isSelected && onSelectToggle) {
      const inTime = data.reg_in_punch || data.in_punch;
      const outTime = data.reg_out_punch || data.out_punch;
    
      if (!inTime || !outTime) {
        alert("❗ Both IN and OUT punch times must be entered before approval.");
        return;
      }
    
      onSelectToggle();
    }
    
  };

  return (
    <div
      className={`attendance-card 
        ${isSelected ? "selected-card" : ""} 
        ${isDisabled ? "disabled-card" : ""} 
        ${isApprovedCard ? "approved-card" : ""}`}
      onDoubleClick={handleDoubleClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchCancel}
    >
      <div className="header">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>{displayText}</span>
            {isApprovedCard && (
              <span className="approved-tag">✔ Approved</span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {!isDisabled && (
              <>
                <input
                  type="checkbox"
                  checked={isSelected}
                  disabled={isDisabled}
                  onChange={() => {
                    if (!isSelected && !canBeApproved()) return;
                    onSelectToggle();
                  }}
                />
              </>
            )}
            {!isDisabled && (
              <button className="reset-btn-header" title="Reset" onClick={resetTimes}>↺</button>
            )}
          </div>
        </div>
      </div>

      <div className="row punch-row" style={{ color: '#8B4513', fontSize: '0.85rem', fontWeight: 500 }}>
        <div className="punch-block">
          <span className="label">Org IN:</span>
          <span className="value">{formatTime(data.in_punch)}</span>
        </div>
        <div className="punch-block">
          <span className="label">Org OUT:</span>
          <span className="value">{formatTime(data.out_punch)}</span>
        </div>
      </div>

      <div className="row punch-row">
        <div className="punch-block">
          <label>IN:</label>
          <input
            type="datetime-local"
            value={regInTime || ""}
            min={data.attendance_date.split('T')[0] + "T00:00"}
            max={data.attendance_date.split('T')[0] + "T23:59"}
            onChange={handleRegInChange}
            disabled={isDisabled}
          />
          {regInTime && !isDisabled && (
            <button className="clear-btn" onClick={() => {
              setRegInTime("");
              onChange({ ...data, reg_in_punch: "", reg_out_punch: regOutTime });
            }}>×</button>
          )}
        </div>

        <div className="punch-block">
          <label>OUT:</label><input
            type="datetime-local"
            value={regOutTime || ""}
            min={data.attendance_date.split('T')[0] + "T00:00"}
            max={(() => {
              const dt = new Date(data.attendance_date);
              dt.setDate(dt.getDate() + 1); // Move to next calendar day
              const nextDay = dt.toISOString().split('T')[0]; // Get YYYY-MM-DD
              return `${nextDay}T23:59`; // Append T23:59
            })()}
            onChange={handleRegOutChange}
            disabled={isDisabled}
          />
          {regOutTime && !isDisabled && (
            <button className="clear-btn" onClick={() => {
              setRegOutTime("");
              onChange({ ...data, reg_in_punch: regInTime, reg_out_punch: "" });
            }}>×</button>
          )}
        </div>
      </div>

      <div className="row status-row" style={{ color: 'steelblue' }}>
        <span>Status: {status}</span>
        <span>Hours: {workingHours}</span>
        <span>OT Hrs: {otHours}</span>
        {!isDisabled && (
          <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <input
              type="checkbox"
              checked={markAbsent}
              onChange={handleMarkAbsentChange}
              style={{ margin: 0 }}
            />
            Mark Absent
          </label>
        )}
      </div>
    </div>
  );
};

export default AttendanceCard;
